import { Sparkles } from "lucide-react";

interface AIInsightProps {
  text: string;
  actionLabel?: string;
  actionHref?: string;
  onAction?: () => void;
}

export function AIInsight({ text, actionLabel, actionHref, onAction }: AIInsightProps) {
  return (
    <div className="flex items-start gap-2.5 px-3 py-2.5 bg-ai-light border border-ai-light rounded-xl">
      <Sparkles size={14} className="text-ai flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-[14px] text-ai leading-relaxed">{text}</p>
        {actionLabel && (
          actionHref ? (
            <a href={actionHref} className="text-[13px] font-medium text-ai underline mt-1 inline-block">
              {actionLabel}
            </a>
          ) : (
            <button onClick={onAction} className="text-[13px] font-medium text-ai underline mt-1">
              {actionLabel}
            </button>
          )
        )}
      </div>
    </div>
  );
}
